import {
  arsc_addExtraWhereClause,
  arsc_addNotToWhereClause,
  arsc_changeSent,
  arsc_loadArsPatch,
  arsc_patchArsState,
  arsc_redoArsChange,
  arsc_removeArsItem,
  arsc_removeNotFromWhereClause,
  arsc_removeWhereClause,
  arsc_setSidebarAnalysisMethodId,
  arsc_setSidebarDataset,
  arsc_setSidebarFilter,
  arsc_setSidebarView,
  arsc_setSidebarWidth,
  arsc_setUiRequestStatus,
  arsc_setVariablesInUse,
  arsc_toggleSidebar,
  arsc_undoArsChange,
} from "./functions";
import {
  ADD_EXTRA_WHERE_CLAUSE,
  ADD_NOT_TO_WHERE_CLAUSE,
  ARS_CHANGE_SENT,
  ArsContextState,
  IArsAction,
  LOAD_ARS_PATCH,
  PATCH_ARS_STATE,
  REDO_ARS_CHANGE,
  REMOVE_ARS_ITEM,
  REMOVE_NOT_FROM_WHERE_CLAUSE,
  REMOVE_WHERE_CLAUSE,
  SET_SIDEBAR_ANALYSIS_METHOD_ID,
  SET_SIDEBAR_DATASET,
  SET_SIDEBAR_FILTER,
  SET_SIDEBAR_VIEW,
  SET_SIDEBAR_WIDTH,
  SET_UI_REQUEST_STATUS,
  SET_VARIABLES_IN_USE,
  TOGGLE_SIDEBAR,
  UNDO_ARS_CHANGE,
} from "./interface";

/**
 * Reducer for ARS context state transitions.
 *
 * @param state - The current ArsContextState
 * @param action - The IArsAction describing the update to apply
 * @returns The updated ArsContextState after applying the action
 */
export const arsContextReducer = <T>(
  state: ArsContextState<T>,
  action: IArsAction,
): ArsContextState<T> => {
  switch (action.operation) {
    case ADD_EXTRA_WHERE_CLAUSE:
      return arsc_addExtraWhereClause(state, action);

    case ARS_CHANGE_SENT:
      return arsc_changeSent(state);

    case ADD_NOT_TO_WHERE_CLAUSE:
      return arsc_addNotToWhereClause(state, action);

    case LOAD_ARS_PATCH:
      return arsc_loadArsPatch(state, action);

    case PATCH_ARS_STATE:
      return arsc_patchArsState(state, action);

    case REMOVE_ARS_ITEM:
      return arsc_removeArsItem(state, action);

    case REMOVE_NOT_FROM_WHERE_CLAUSE:
      return arsc_removeNotFromWhereClause(state, action);

    case REDO_ARS_CHANGE:
      return arsc_redoArsChange(state, action);

    case REMOVE_WHERE_CLAUSE:
      return arsc_removeWhereClause(state, action);

    case SET_SIDEBAR_VIEW:
      return arsc_setSidebarView(state, action);

    case SET_SIDEBAR_ANALYSIS_METHOD_ID:
      return arsc_setSidebarAnalysisMethodId(state, action);

    case SET_SIDEBAR_DATASET:
      return arsc_setSidebarDataset(state, action);

    case SET_SIDEBAR_FILTER:
      return arsc_setSidebarFilter(state, action);

    case SET_SIDEBAR_WIDTH:
      return arsc_setSidebarWidth(state, action);

    case SET_UI_REQUEST_STATUS:
      return arsc_setUiRequestStatus(state, action);

    case SET_VARIABLES_IN_USE:
      return arsc_setVariablesInUse(state, action);

    case TOGGLE_SIDEBAR:
      return arsc_toggleSidebar(state, action);

    case UNDO_ARS_CHANGE:
      return arsc_undoArsChange(state, action);

    default:
      return state;
  }
};
